/**
 * Per-room chat (#1782).
 * Plot Grid is the Outline step, so it uses the Outline thread.
 * Idea holds every session that already exists.
 */

export const PANE_ROOM_KEYS = ['outline', 'write', 'notes', 'docs'];
export const DEFAULT_ROOM_KEY = 'idea';

export const ROOM_CHAT_EMPTY = "This room's chat starts here.";
export const ROOM_CHAT_OPENING = "Opening this room's chat.";

const SUBJECT_ROOM = {
  Idea: 'idea',
  Outline: 'outline',
  Write: 'write',
  Notes: 'notes',
  Docs: 'docs',
};

const ROOM_LABEL_BY_KEY = {
  idea: 'Idea',
  outline: 'Outline',
  write: 'Write',
  notes: 'Notes',
  docs: 'Docs',
};

// Stored session names. Series Discovery is a series notebook, not this map.
const INTERNAL_ROOM_NAME = {
  discovery: 'idea',
  'plot grid': 'outline',
  'scene writing': 'write',
  'book notes': 'notes',
};

export function roomKeyForSubject(subject) {
  return SUBJECT_ROOM[subject] || null;
}

/**
 * Writer-facing room label. Discovery, Plot Grid, Scene Writing, and
 * Book Notes become Idea, Outline, Write, and Notes. A name the writer
 * chose stays as they wrote it.
 */
export function writerFacingRoomName(name, roomKey, sessionType) {
  const key = String(roomKey || '').trim().toLowerCase();
  const kind = String(sessionType || '').trim().toLowerCase();
  const text = name == null ? '' : String(name).trim();
  if (!text) {
    if (kind === 'discovery') return ROOM_LABEL_BY_KEY.idea;
    if (ROOM_LABEL_BY_KEY[key]) return ROOM_LABEL_BY_KEY[key];
    return '';
  }
  let base = text;
  let suffix = '';
  const numbered = text.match(/^(.+?) (\d+)$/);
  if (numbered) {
    base = numbered[1];
    suffix = ` ${numbered[2]}`;
  }
  const folded = base.toLowerCase();
  const internal = INTERNAL_ROOM_NAME[folded];
  if (internal) return `${ROOM_LABEL_BY_KEY[internal]}${suffix}`;
  if (ROOM_LABEL_BY_KEY[folded]) return `${ROOM_LABEL_BY_KEY[folded]}${suffix}`;
  return text;
}

export function isPaneRoomSession(session) {
  return PANE_ROOM_KEYS.includes(String(session?.room_key || '').toLowerCase());
}

export function roomSessionStorageKey(storyId, roomKey, sceneId) {
  const base = `brainstormy.roomChat.${storyId}.${roomKey}`;
  if (roomKey === 'write' && sceneId) return `${base}.${sceneId}`;
  return base;
}

export function readRoomSessionId(storyId, roomKey, sceneId) {
  if (!storyId || !roomKey) return null;
  try {
    return localStorage.getItem(roomSessionStorageKey(storyId, roomKey, sceneId)) || null;
  } catch {
    return null;
  }
}

export function rememberRoomSessionId(storyId, roomKey, sessionId, sceneId) {
  if (!storyId || !roomKey) return;
  try {
    const key = roomSessionStorageKey(storyId, roomKey, sceneId);
    if (sessionId) localStorage.setItem(key, sessionId);
    else localStorage.removeItem(key);
  } catch {
    /* the room still opens the latest thread */
  }
}
